import {
  Box,
  BoxProps,
  forwardRef,
} from '@chakra-ui/react';
import {
  ReactNode
} from 'react';

export type PcSideButtonProps = {
  bg: 'orange' | 'brand.500',
  icon: ReactNode;
  children: ReactNode;
} & BoxProps;

export const PcSideButton = forwardRef(({
  bg,
  icon,
  children,
  ...props
}: PcSideButtonProps, ref) => {
  return (
    <Box
      ref={ref}
      bg={bg}
      w={14}
      h={60}
      color={'white'}
      fontWeight={'bold'}
      textStyle={'h5'}
      letterSpacing={'3px'}
      css={{
        writingMode: 'vertical-rl',
        textOrientation: 'upright'
      }}
      textAlign={'center'}
      position={'fixed'}
      right={0}
      zIndex={5}
      cursor={'pointer'}
      pr={2}
      borderTopLeftRadius={15}
      borderBottomLeftRadius={15}
      {...props}
    >
      {icon}
      {children}
    </Box>
  );
});
